//
// AxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "./AxisType";
import "./AxisDisplay";
import "./AxisOffsetType";
import "../core/styles/LineAttributes";
import "./AxisTickStyle";
import "./AxisGridDisplay";
import "@sas-dvr/ltjs-commons/styles/GridLayer";
import "./AxisLabelPosition";
import "../core/styles/TextAttributes";
import "./DiscreteAxisOptions";
import "./LinearAxisOptions";
import "./LogarithmicAxisOptions";
import "./LogModulusAxisOptions";
import "./TimeAxisOptions";
import "./AbstractSpecializedAxis";
import "./AxisLabelFitPolicy";
import "../core/Justification";
import "./AxisLineExtentType";

var AxisOptions = createModule("gtl_AxisOptions", [130,13,20148,20355,20045], EventDispatcher, [
    ,
    {
        discreteOptions: 1,
        gridDisplay: 4,
        specializedAxis: 1,
        logModulusOptions: 1,
        lineExtentType: 4,
        offsetMinType: 4,
        type: 4,
        lineExtent: 6,
        labelSplitChar: 7,
        tickStyle: 4,
        gridLayer: 4,
        labelPosition: 4,
        shortLabel: 7,
        labelSplitJustify: 4,
        offsetMin: 5,
        confineMinMaxTickValues: 2,
        labelSplitCharDrop: 2,
        displaySecondary: 1,
        display: 1,
        tickValueAttributes: 1,
        timeOptions: 1,
        labelFitPolicy: 4,
        label: 7,
        reverse: 2,
        linearOptions: 1,
        offsetMaxType: 4,
        offsetMax: 5,
        lineAttributes: 1,
        stackedLabels: 2,
        labelAttributes: 1,
        gridAttributes: 1,
        logOptions: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default AxisOptions;
